module.exports = __webpack_public_path__ + "img/faqIsOpened.9ba0c5df.svg";